/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Connections_Toggle_AriaInputs */



/**
* | output |
* | --- |
* | "Enable {name} for me" |
*
* @param {Connections_Toggle_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_toggle_aria = /** @type {((inputs: Connections_Toggle_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Toggle_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} für mich aktivieren`)
	return /** @type {LocalizedString} */ (`Enable ${i?.name} for me`)
});